import styled from "styled-components";
import { appVersion, thisYear } from "../helpers/format";

const AppVersion = () => {
	return (
		<VersionApp>
			v{appVersion} · © {thisYear}. {process.env.REACT_APP_WEBSITE_NAME}
		</VersionApp>
	);
};

const VersionApp = styled.div`
	padding: 10px;
	padding-left: 8px;
	margin: 0px;
	text-align: center;
	font-size: ${({ theme }) => theme.fontSize.smallText};
	color: ${({ theme }) => theme.colors.charcoal400};
`;
export default AppVersion;
